export default {
  "hero.title": "USFans Spreadsheet — Find, Compare & Research USFans Resources",
  "hero.subtitle": "Explore USFans Spreadsheet resources, practical guides, seller information, comparisons, shipping insights and safety tips — all organized in one easy-to-use resource hub.",
  "hero.support": "Looking for a clearer way to research USFans resources? Start with our organized USFans Spreadsheet guides, comparisons and practical research tools.",
  "hero.ctaPrimary": "Explore USFans Spreadsheet",
  "hero.ctaSecondary": "Start With the Beginner Guide",
  "hero.badge": "Independent resource hub",

  "trust.1": "Independent Resource",
  "trust.2": "Updated Guides",
  "trust.3": "Multilingual Content",
  "trust.4": "Safety-Focused Research",

  "jump.title": "Visit Our Store",
  "jump.subtitle": "Ready to browse the full product range? Head straight to the official store.",
  "jump.primary": "USFans Spreadsheet",
  "jump.secondary": "Buy It Now",

  "whatIs.title": "What Is USFans Spreadsheet?",
  "whatIs.text": "USFans Spreadsheet is commonly used as a way to organize and research product, seller and purchasing information. Our resource hub helps beginners and experienced users understand spreadsheet information, compare options, evaluate important details and research more carefully.",
  "whatIs.cta": "Explore the USFans Spreadsheet Guide",

  "research.title": "Everything You Need to Research USFans",
  "research.subtitle": "A structured set of resources covering the most important angles when researching USFans.",
  "research.spreadsheet.title": "USFans Spreadsheet",
  "research.spreadsheet.text": "Explore the core spreadsheet resource and learn how to read and research information.",
  "research.review.title": "USFans Review",
  "research.review.text": "Understand what to check when researching USFans reviews, reputation and user experiences.",
  "research.shipping.title": "USFans Shipping Cost",
  "research.shipping.text": "Learn which factors can affect shipping costs and what information to compare.",
  "research.warehouse.title": "USFans Warehouse",
  "research.warehouse.text": "Understand warehouse-related information, storage concepts and common questions.",
  "research.coupon.title": "USFans Coupon",
  "research.coupon.text": "Learn how to research USFans coupons, promotions and discount information.",
  "research.safety.title": "USFans Safety",
  "research.safety.text": "Identify common risks, suspicious claims and important safety considerations.",

  "compare.title": "Compare USFans Resources Before You Decide",
  "compare.text": "Different resources can provide different levels of information. Use our comparison guides to evaluate categories, available information, QC details, shipping information and potential limitations before making a decision.",
  "compare.cta": "View USFans Comparisons",

  "beginner.title": "New to USFans? Start Here.",
  "beginner.subtitle": "A simple three-step path to research with more confidence.",
  "beginner.step1.title": "Find",
  "beginner.step1.text": "Discover relevant USFans Spreadsheet resources.",
  "beginner.step2.title": "Compare",
  "beginner.step2.text": "Compare available information and understand the differences.",
  "beginner.step3.title": "Research",
  "beginner.step3.text": "Review safety, shipping, warehouse and other important details.",
  "beginner.cta": "Read the Complete Beginner Guide",

  "guides.title": "USFans Review, Shipping, Warehouse & Discount Guides",
  "guides.subtitle": "Dedicated resources for the topics people search for most.",
  "guides.review.title": "USFans Review",
  "guides.review.text": "What to check before trusting a review.",
  "guides.shipping.title": "USFans Shipping Cost",
  "guides.shipping.text": "Factors that affect shipping fees.",
  "guides.coupon.title": "USFans Coupon",
  "guides.coupon.text": "How to research promotions.",
  "guides.discount.title": "USFans Discount Code",
  "guides.discount.text": "What to check before using one.",
  "guides.warehouse.title": "USFans Warehouse",
  "guides.warehouse.text": "Storage concepts and common questions.",
  "guides.legit.title": "USFans Legit",
  "guides.legit.text": "Signals of legitimacy and caution.",

  "category.title": "Browse Products by Category",
  "category.subtitle": "Jump straight to any product category in the store.",
  "category.dropdownLabel": "Choose a category",
  "category.all": "All Categories",

  "article.title": "Latest USFans Spreadsheet Guides",
  "article.subtitle": "Fresh, original guides to help you research with confidence.",

  "safety.title": "USFans Spreadsheet Safety Center",
  "safety.text": "Online purchasing research requires careful verification. Our safety center explains how to identify suspicious information, evaluate claims, protect personal information and verify important details before taking action.",
  "safety.cta": "Read the Safety Guide",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is USFans Spreadsheet?",
  "faq.a1": "USFans Spreadsheet is a way to organize and research product, seller and purchasing information in one place, making it easier to compare options and evaluate details.",
  "faq.q2": "How does USFans Spreadsheet work?",
  "faq.a2": "It organizes structured information such as products, sellers, pricing and shipping details into columns and rows, so you can scan and compare data more efficiently.",
  "faq.q3": "How do I read a USFans Spreadsheet?",
  "faq.a3": "Start with the column headers, then follow each row to understand the data for a specific product or seller. Check the key columns such as name, price, QC and shipping.",
  "faq.q4": "Is USFans legit?",
  "faq.a4": "Legitimacy depends on the source you are reviewing. Always cross-check information, look for verifiable details and be cautious with claims that seem too good to be true.",
  "faq.q5": "How much does USFans shipping cost?",
  "faq.a5": "Shipping costs vary based on destination, weight, carrier and other factors. Compare multiple sources and confirm the final cost before purchasing.",
  "faq.q6": "Does USFans have coupons?",
  "faq.a6": "Promotions and coupons can appear over time. Verify any coupon or discount code directly and be careful with unofficial or unverifiable offers.",
  "faq.q7": "Where is the USFans warehouse?",
  "faq.a7": "Warehouse details can change. Check official or up-to-date sources for the most accurate location and storage information.",
  "faq.q8": "How can I verify USFans information?",
  "faq.a8": "Cross-check multiple independent sources, look for dates and updates, and confirm key details directly before making decisions.",

  "final.title": "Ready to Explore USFans Spreadsheet?",
  "final.text": "Start with the USFans Spreadsheet guide, compare relevant resources and learn how to research important information with greater confidence.",
  "final.ctaPrimary": "Explore USFans Spreadsheet",
  "final.ctaSecondary": "Browse All Guides"
};